/* eslint-disable react/display-name */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  background: ",
        ";\n  border: none;\n  display: inline-block;\n  height: 32px;\n  line-height: 32px;\n  padding: 0 12px;\n  border-radius: 3px;\n  color: ",
        ";\n  text-decoration: none;\n  vertical-align: top;\n  &[disabled] {\n    background: #ccc;\n    cursor: not-allowed;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  height: 100%;\n  width: 20px;\n  height: 22px;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import React from 'react';
import styled from '@emotion/styled';
export var BaseButtonStyle = {
    fontFamily: 'Inter, sans-serif !important',
    rounded: 'md',
    lineHeight: 1,
    fontWeight: 'medium',
    boxShadow: 'none'
};
var BasePrimaryStyle = _object_spread_props(_object_spread({}, BaseButtonStyle), {
    size: 'md',
    colorScheme: 'blue',
    variant: 'solid'
});
var BaseSecondaryStyle = _object_spread_props(_object_spread({}, BaseButtonStyle), {
    size: 'md',
    border: 'none',
    colorScheme: 'blue',
    variant: 'subtle',
    _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed',
        _hover: {
            bg: 'blue.100'
        }
    }
});
var OutlineButtonBase = _object_spread_props(_object_spread({}, BaseButtonStyle), {
    bg: 'none',
    size: 'md',
    color: 'gray.800',
    border: '1px solid',
    borderColor: 'gray.700',
    fontWeight: 'semibold',
    rounded: 'md',
    _hover: {
        bg: 'blue.50'
    },
    _focus: {
        bg: 'blue.100'
    },
    _active: {
        bg: 'blue.100'
    }
});
export var Buttons = {
    Outline: _object_spread({}, OutlineButtonBase),
    Primary: _object_spread({}, BasePrimaryStyle),
    PrimarySmall: _object_spread_props(_object_spread({}, BasePrimaryStyle), {
        size: 'sm'
    }),
    Secondary: _object_spread({}, BaseSecondaryStyle),
    SecondarySmall: _object_spread_props(_object_spread({}, BaseSecondaryStyle), {
        px: 3,
        rounded: '5px',
        height: '32px',
        fontSize: 'md'
    }),
    Ghost: _object_spread_props(_object_spread({}, BaseButtonStyle), {
        px: 4,
        variant: 'ghost',
        colorScheme: 'blue',
        fontWeight: 'medium',
        size: 'sm',
        h: 10
    })
};
export var Button = styled.button(_templateObject(), function(props) {
    return props.background || '#CCC';
}, function(props) {
    return props.color || '#666';
});
var ButtonLoading = styled.div(_templateObject1());
var SpinLoading = styled.div(_templateObject2());
var ButtonContent = styled.div(_templateObject3(), function(props) {
    return props.isLoading && 'transparent';
});
export default function(_param) {
    var children = _param.children, loading = _param.loading, disabled = _param.disabled, props = _object_without_properties(_param, [
        "children",
        "loading",
        "disabled"
    ]);
    return /*#__PURE__*/ React.createElement(Button, _object_spread_props(_object_spread({}, props), {
        disabled: loading || disabled
    }), /*#__PURE__*/ React.createElement(ButtonContent, {
        isLoading: loading
    }, children), loading && /*#__PURE__*/ React.createElement(ButtonLoading, null, /*#__PURE__*/ React.createElement(SpinLoading, null, /*#__PURE__*/ React.createElement("svg", {
        fill: "#fff",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32"
    }, /*#__PURE__*/ React.createElement("path", {
        opacity: ".25",
        d: "M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z",
        transform: "rotate(218.551 16 16)"
    }, /*#__PURE__*/ React.createElement("animateTransform", {
        attributeName: "transform",
        type: "rotate",
        from: "0 16 16",
        to: "360 16 16",
        dur: "0.8s",
        repeatCount: "indefinite"
    }))))));
};
